/* eslint-disable no-unused-vars */
import { connect } from 'react-redux';
import { getScreenData, Store, formatMessage, removeScreenData, setScreenData } from 'cw-ui-core';
import Locale from 'src/i18n';
import UserGridFilters from 'src/features/users/components/UserGridFilters/UserGridFilters';
import { toArray } from 'src/util/Util';
import { loadUsersWithConnectedApps } from 'src/services/UsersService';
import { getConnectedAppInstanceName } from 'src/services/ConnectedAppsService';
import {
    MFA_IDS_CONSTANTS,
    USER_STATUS_CONSTANTS,
    FILTER_IDS,
} from 'src/features/users/constants/gridFiltersConstants';
import _ from 'lodash';
import { LOCAL_LOGIN } from 'src/constants';

const { EMAIL_MFA_ID, AUTHENTICATOR_MFA_ID, DUO_MFA_ID } = MFA_IDS_CONSTANTS;

const { ACTIVE, PENDING, EXPIRED, DISABLED } = USER_STATUS_CONSTANTS;

const { ROLES_ID, STATUS_ID, AUTH_ID, MFA_ID, CONNECTED_APPS_ID } = FILTER_IDS;

const mapStateToProps = state => {
    const loginProviders = toArray(getScreenData(state.screen, ['loginProviders']));

    const connectedAppsIsReady = getScreenData(state.screen, ['isInstanceNameReady']) ?? true;
    // eslint-disable-next-line no-unused-vars
    let connectedAppsList = [];

    if (connectedAppsIsReady) {
        const connectedApps = toArray(getScreenData(state.screen, ['connectedAppInstanceNames']));
        connectedAppsList = _.map(connectedApps, app => ({
            id: app.id,
            name: !app.instanceFriendlyName
                ? `${app.applicationBaseName}`
                : `${app.applicationBaseName} (${app.instanceFriendlyName})`,
        }));
    }

    const loginProvidersList = [{ id: 'Local Login', name: 'Local Login', scheme: null }].concat(
        loginProviders.map(x => ({
            id: x.scheme,
            name: x.clientName,
            scheme: x.scheme,
        }))
    );

    const rolesList = toArray(getScreenData(state.screen, ['roles']));

    const defaultMfaList = [
        { id: EMAIL_MFA_ID, name: formatMessage(Locale.userEmailMfa) },
        { id: AUTHENTICATOR_MFA_ID, name: formatMessage(Locale.userAuthMfa) },
        { id: DUO_MFA_ID, name: formatMessage(Locale.userDuoMfa) },
    ];

    const userStatusList = [
        { id: ACTIVE, name: formatMessage(Locale.userStatusActive) },
        { id: PENDING, name: formatMessage(Locale.userStatusPending) },
        { id: EXPIRED, name: formatMessage(Locale.expired) },
        { id: DISABLED, name: formatMessage(Locale.disabled) },
    ];

    const data = [
        {
            id: ROLES_ID,
            filterList: rolesList,
            placeholder: formatMessage(Locale.allRoles),
            selectedValue: getScreenData(Store().getState().screen, ['addFilter', ROLES_ID])?.toJS() ?? [],
        },
        {
            id: STATUS_ID,
            filterList: userStatusList,
            placeholder: formatMessage(Locale.allStatuses),
            selectedValue: getScreenData(Store().getState().screen, ['addFilter', STATUS_ID])?.toJS() ?? [],
        },
        {
            id: AUTH_ID,
            filterList: loginProvidersList,
            placeholder: formatMessage(Locale.allAuthentication),
            selectedValue: getScreenData(Store().getState().screen, ['addFilter', AUTH_ID])?.toJS() ?? [],
        },
        {
            id: MFA_ID,
            filterList: defaultMfaList,
            placeholder: formatMessage(Locale.allMfaProviders),
            selectedValue: getScreenData(Store().getState().screen, ['addFilter', MFA_ID])?.toJS() ?? [],
        },
        // TODO: Add the details for connected apps filter later once the performance of grid is improved.
    ];

    return {
        data,
        connectedAppsIsLoading: !connectedAppsIsReady,
        connectedAppsId: CONNECTED_APPS_ID,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setValueInDropdown: (value, id) => {
            switch (id) {
                case ROLES_ID:
                    dispatch(setScreenData(['addFilter', ROLES_ID], value));
                    break;
                case STATUS_ID:
                    dispatch(setScreenData(['addFilter', STATUS_ID], value));
                    break;
                case AUTH_ID:
                    if (_.size(value) > 0 && !_.includes(value, LOCAL_LOGIN))
                        dispatch(removeScreenData(['addFilter', MFA_ID]));
                    dispatch(setScreenData(['addFilter', AUTH_ID], value));
                    break;
                case MFA_ID:
                    dispatch(setScreenData(['addFilter', MFA_ID], value));
                    break;
                case CONNECTED_APPS_ID:
                    dispatch(setScreenData(['addFilter', CONNECTED_APPS_ID], value));
                    break;
                default:
                    break;
            }
        },
        onApply: () => {
            const searchText = getScreenData(Store().getState().screen, ['usersSearchText']);
            const filters = toArray(getScreenData(Store().getState().screen, ['addFilter']));
            Store().runSaga(loadUsersWithConnectedApps, 1, 50, searchText, filters);
            ownProps.setIsFilterFlyout(false);
        },
        onReset: () => {
            dispatch(removeScreenData(['addFilter']));
        },
        onConnectedAppsFilterClick: () => {
            const connectedAppsIsReady = getScreenData(Store().getState().screen, ['isInstanceNameReady']);
            if (!connectedAppsIsReady) {
                Store().runSaga(getConnectedAppInstanceName);
            }
        },
    };
};

const UserGridFiltersContainer = connect(mapStateToProps, mapDispatchToProps)(UserGridFilters);

export default UserGridFiltersContainer;
